import React, { lazy } from "react";
import { Route, Redirect } from "react-router-dom";
import BlankLayout from "@layouts/BlankLayout";

const PrivateRoute = (props) => {
  if (window.localStorage.getItem("user")) {
    if (
      !props?.roles?.includes(
        JSON.parse(window.localStorage.getItem("user"))?.role
      )
    ) {
      return (
        <Route
          path={props.path}
          component={lazy(() => import("./views/NotAuthorized"))}
        />
      );
    }
    else if(JSON.parse(window.localStorage.getItem("user"))?.role === "ADMIN" &&  JSON.parse(localStorage.getItem("entity")) === null){
        return (
          <Redirect push to="/wizard" />
        );
    } else if(JSON.parse(window.localStorage.getItem("user"))?.authenticator_type === 2 && JSON.parse(window.localStorage.getItem("user"))?.otp_verified === false){
      return (
        <Redirect push to="/verify-code" />
      );
    }else if(JSON.parse(window.localStorage.getItem("user"))?.authenticator_type === 1 && JSON.parse(window.localStorage.getItem("user"))?.otp_verified === false){
      return (
        <Redirect push to="/verify-2fa" />
      );
    } else {

      if (
        localStorage.getItem("user") &&
        JSON.parse(localStorage.getItem("entity")) === null
      ) {
        return (
          <Route
            path={props.path}
            render={() => {
              return (
                <BlankLayout>
                  <Route {...props} />
                  {/* <props.component /> */}
                </BlankLayout>
              );
            }}
          />
        );
      } else {
        return <Route {...props} />;
      }
    }
  } else {
    return <Redirect to="/" />;
  }
};
export default PrivateRoute;
